export const LOGO_URL = "https://customer-assets.emergentagent.com/job_d138d92c-f6a1-45b2-9ba5-7a48a33481a3/artifacts/7g3ygwvs_Logo.png";

// Success Stories — Ocean Isle Beach featured + property gallery
export const FEATURED_PROPERTY = "https://customer-assets.emergentagent.com/job_advisory-studio/artifacts/3tsn4cwq_IMG_6984.jpeg";
export const PROPERTY_GALLERY = [
  "https://customer-assets.emergentagent.com/job_advisory-studio/artifacts/lh2trjf8_IMG_6982.jpeg",
  "https://customer-assets.emergentagent.com/job_advisory-studio/artifacts/1wfpdovv_MSR_6892.jpg-SMALL.jpeg",
  "https://customer-assets.emergentagent.com/job_advisory-studio/artifacts/7vbkf3w9_DJI_0414.jpg-SMALL.jpeg",
  "https://customer-assets.emergentagent.com/job_advisory-studio/artifacts/iil5c1ph_IMG_6980.jpeg",
  "https://customer-assets.emergentagent.com/job_advisory-studio/artifacts/3ar31j7j_IMG_3155.jpeg",
  "https://customer-assets.emergentagent.com/job_advisory-studio/artifacts/8ztctxnb_IMG_6983.jpeg",
];

// Lead magnet PDF
export const SCORECARD_PDF = "https://customer-assets.emergentagent.com/job_advisory-studio/artifacts/d4rnmohd_Leak%20Audit.pdf";
export const SCORECARD_FILENAME = "Revenue-Leak-Audit-Scorecard.pdf";

// Hero — Sarah portrait + workspace detail (asymmetric editorial split)
export const HERO_PORTRAIT = "https://customer-assets.emergentagent.com/job_d138d92c-f6a1-45b2-9ba5-7a48a33481a3/artifacts/72ui2rin_IMG_2061.jpeg";
export const HERO_DETAIL = "https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=900&q=80";

// About — use the second portrait on the home page About block so the page doesn't repeat the hero image
export const ABOUT_IMAGE_1 = "https://customer-assets.emergentagent.com/job_d138d92c-f6a1-45b2-9ba5-7a48a33481a3/artifacts/4vuw8et6_IMG_2009.jpeg";
export const ABOUT_IMAGE_2 = "https://customer-assets.emergentagent.com/job_d138d92c-f6a1-45b2-9ba5-7a48a33481a3/artifacts/72ui2rin_IMG_2061.jpeg";

// Boutique hospitality interiors — curated, natural light
export const HOSPITALITY = {
  livingRoom: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1200&q=80",
  bedroom: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1200&q=80",
  diningNook: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=80",
  hallway: "https://images.unsplash.com/photo-1560448204-603b3fc33ddc?auto=format&fit=crop&w=1200&q=80",
  textures: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1200&q=80",
  windowLight: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1200&q=80",
  workspace: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Resources", to: "/resources" },
  { label: "Success Stories", to: "/success-stories" },
  { label: "Blog", to: "/blog" },
];
